import React, { useEffect, useRef, useState } from "react";
import ApexCharts from "apexcharts";
import axios from "axios";

const WalletGraph = () => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  const [chartD, setChartD] = useState("1m");
  const [selectedDay, setSelectedDay] = useState("1m");

  useEffect(() => {
    graphData("1m");

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, []);

  const formatDateString = (date) => {
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;

    return `${year}-${month}-${day}`;
  };

  const graphData = async (duration = chartD) => {
    const currentDate = new Date();
    const currentDateInput = formatDateString(currentDate);

    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);

    const threeMonthsPrevious = new Date();
    threeMonthsPrevious.setMonth(threeMonthsPrevious.getMonth() - 3);

    const sixMonthsPrevious = new Date();
    sixMonthsPrevious.setMonth(sixMonthsPrevious.getMonth() - 6);

    const oneYearPrevious = new Date();
    oneYearPrevious.setFullYear(oneYearPrevious.getFullYear() - 1);

    let fromDate;

    switch (duration) {
      case "1m":
        fromDate = formatDateString(lastMonth);
        break;
      case "3m":
        fromDate = formatDateString(threeMonthsPrevious);
        break;
      case "6m":
        fromDate = formatDateString(sixMonthsPrevious);
        break;
      case "1y":
        fromDate = formatDateString(oneYearPrevious);
        break;
      case "d":
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        fromDate = formatDateString(yesterday);
        break;
      default:
        fromDate = formatDateString(lastMonth);
    }

    const inputObj = {
      fromDate,
      toDate: currentDateInput,
      userId: localStorage.getItem("userId"),
      uuid: localStorage.getItem("uuid"),
      chartDuration: duration,
    };

    try {
      const res = await axios.post(
        "https://accounts.paybito.com/api/transaction/GetUserPortfolioGraph",
        inputObj,
        { headers: { "Content-Type": "application/json" } }
      );

      const responseData = res?.data?.response || [];

      // ✅ FIX: seconds → milliseconds + sorting
      const graphDataArr = responseData
        .sort((a, b) => a.HIST_DATE - b.HIST_DATE)
        .map((item) => [item.HIST_DATE * 1000, item.VALUE]);

      const isDarkTheme =
        document.body.classList.contains("dark-theme") ||
        document.documentElement.getAttribute("data-theme") === "dark" ||
        window.matchMedia("(prefers-color-scheme: dark)").matches;

      const options = {
        series: [
          {
            name: "Portfolio Value",
            data: graphDataArr,
          },
        ],
        chart: {
          type: "area",
          height: 350,
          zoom: { enabled: true },
          background: isDarkTheme ? "#1a1a1a" : "#ffffff",
          foreColor: isDarkTheme ? "#ffffff" : "#373d3f",
        },
        theme: {
          mode: isDarkTheme ? "dark" : "light",
        },
        dataLabels: { enabled: false },
        stroke: {
          curve: "smooth",
          width: 2,
        },
        fill: {
          type: "gradient",
          gradient: {
            opacityFrom: 0.5,
            opacityTo: 0,
          },
        },
        xaxis: {
          type: "datetime",
          title: { text: "Day" },
        },
        yaxis: {
          labels: {
            formatter: function (val) {
              return Math.round(val).toLocaleString(); // ✅ FIX HERE
            },
          },
          title: {
            text: "Balance (USD)",
          },
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy",
          },
          y: {
            formatter: (val) => `$${Math.round(val).toLocaleString()}`, // ✅ clean tooltip
          },
        },
        grid: {
          borderColor: isDarkTheme ? "#444" : "#e0e0e0",
        },
      };

      if (chartInstance.current) {
        chartInstance.current.destroy();
      }

      chartInstance.current = new ApexCharts(chartRef.current, options);
      chartInstance.current.render();
    } catch (error) {
      console.error("Chart API Error:", error);
    }
  };

  const handleSelect = (e) => {
    const selected = e.target.value;
    setSelectedDay(selected);
    setChartD(selected);
    graphData(selected);
  };

  return (
    <div className="position-relative">
      <select
        className="chart_dropdown"
        onChange={handleSelect}
        value={selectedDay}
      >
        <option value="d">1d</option>
        <option value="1m">1m</option>
        <option value="3m">3m</option>
        <option value="6m">6m</option>
        <option value="1y">1y</option>
      </select>

      <div ref={chartRef}></div>
    </div>
  );
};

export default WalletGraph;
